import { type Movie, type Tv } from '@tmdb-graphql-api/schema/types';

export type MovieReviewsData = {
  movie: Pick<Movie, 'reviews'>;
};

export type TvReviewsData = {
  tv: Pick<Tv, 'reviews'>;
};

export const getReviewsTotal = (data: MovieReviewsData | TvReviewsData | null | undefined) => {
  if (!data) {
    return 0;
  }

  if ('movie' in data) {
    return data.movie.reviews?.totalCount ?? 0;
  }

  return data.tv.reviews?.totalCount ?? 0;
};
